import { Organisation } from "./Organisation.model";
import { useUsersStore } from "@/stores/Users.store";
import { GoalCollection } from "@/models/GoalCollection.model.ts";
import { Model } from "@/stores/AbstractBase.store.ts";

export class Classroom implements Model {

	public id ?: string;
	public name ?: string;
	public organisation ?: Organisation;
	public features: string[] = [];

	public pupilCount ?: number = 0;
	public teachers ?: string[] = [];
	public broadcast_channel ?: string;
	public goalCollections: GoalCollection[] = [];

	static mapFromServer(data: any) {
		console.error('mapFromServer is deprecated, use createFromApiData instead');
		const classroom = new Classroom();
		classroom.setFromServerData(data);

		return classroom;
	}

	static createFromApiData(data: any) {
		const classroom = new Classroom();
		classroom.hydrateWithApiData(data);

		return classroom;
	}

	/**
	 * Get the ID of the classroom.
	 * Difference with the id property: this method throws an error if the classroom has no id.
	 * @returns string
	 */
	public getId(): string {
		if (!this.id) {
			throw new Error('Classroom has no id');
		}
		return this.id;
	}

	public hasId(): boolean {
		return !!this.id;
	}

	hydrateWithApiData(data: any) {
		this.id = data.id;
		this.name = data.name;
		this.pupilCount = data.pupilCount;

		if (data.broadcast_channel) {
			this.broadcast_channel = data.broadcast_channel;
		}

		if (data.organisation) {
			this.organisation = Organisation.mapFromServer(data.organisation);
		}

		if (data.features) {
			this.features = data.features;
		}

		if (data.teachers) {
			this.teachers = data.teachers.map((teacher: any) => {
				return teacher.id;
			});
		}

		if (data.goalCollections) {
			this.goalCollections = data.goalCollections.map((goalCollection: any) => {
				return GoalCollection.createFromApiData(goalCollection);
			});
		}
	}

	setFromServerData(data: any) {
		console.warn('setFromServerData is deprecated, use hydrateWithApiData instead');
		this.hydrateWithApiData(data);
	}

	getTeachers() {
		if (!this.teachers) {
			return [];
		}
		return useUsersStore().fromIds(this.teachers);
	}

	asApiDataObject() {
		return {
			id: this.id,
			name: this.name,
			teachers: this.teachers ? this.teachers.map(teacherId => { return { id: teacherId } }) : null,
			broadcast_channel: this.broadcast_channel,
			pupilCount: this.pupilCount,
		}
	}

	equals(other: Classroom) {
		return this.getId() === other.getId();
	}

	clone(): Classroom {
		let clonedInstance = Object.assign(
			Object.create(
				Object.getPrototypeOf(this)
			),
			this
		);
		return clonedInstance;
	}
}
